export default __webpack_public_path__ + "static/media/WORLD_LANGUAGES_MANDARIN_CHINESE.5a492145.svg";